import React from 'react';
import PropTypes from 'prop-types';

import Partner from '../../../models/partner';
import { ContextMenu, Button, Dropdown, Status } from '@weezevent/nacre';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { infoStatusDisplay } from '../../../pages/partner/PartnersList';

function PartnerPrimaryCTA({ organization, partner }) {
    const history = useHistory();
    const { t } = useTranslation();
    return (
        <Button
            style={{ width: '100%' }}
            primary
            disabled={partner?.isDeleted()}
            label={t('context_menu.cta_create_batch_booking')}
            onClick={() => history.push(`/ticket/O${organization.id}/partners/${partner.pk}/batches/new`)}
        />
    );
}

export default function PartnerContextMenu({ organization, event, partner }) {
    const { t } = useTranslation();
    const history = useHistory();
    const status = infoStatusDisplay(partner);

    const [filteredPartners, setFilteredPartners] = React.useState(null);
    const [partners, loading, , error] = Partner.useApiModel({
        organizationId: organization.id,
        onSuccess: partners => setFilteredPartners(partners)
    });

    const switchProps = React.useMemo(() => {
        if (loading || error) {
            return {};
        }

        return {
            switchMenuProps: {
                text: t('context_menu.partners.search_partner'),
                items: filteredPartners.map(partner => {
                    return (
                        <Dropdown.Item
                            key={partner.uuid}
                            onClick={() => {
                                history.push(`/ticket/O${organization.id}/partners/${partner.uuid}`);
                            }}
                        >
                            {partner.name}
                        </Dropdown.Item>
                    );
                }),
                searchProps: {
                    placeholder: t('context_menu.partners.search_placeholder'),
                    onChange: (s, val) => {
                        // We don't handle pagination yet for partners
                        if (!val) {
                            return setFilteredPartners(partners);
                        }

                        setFilteredPartners(
                            partners.filter(({ name }) => {
                                let reg = new RegExp(val, 'gi');
                                return reg.test(name);
                            })
                        );
                    },
                    handleReset: () => {
                        return setFilteredPartners(partners);
                    }
                }
            }
        };
    }, [filteredPartners, partners, loading, error, t]);

    return (
        <ContextMenu
            cta={<PartnerPrimaryCTA organization={organization} partner={partner} />}
            title={partner.name}
            catchphrase={t('context_menu.catchphrase_partner')}
            {...switchProps}
            status={<Status color={status.color} text={status.text} />}
        />
    );
}

PartnerContextMenu.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    partner: PropTypes.object.isRequired
};
